export default __webpack_public_path__ + "static/media/nopermission.0c1dcbdb.png";